import { useNavigate } from "react-router-dom";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useMessage } from "../../global-components/src";
import Spinner from "../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useAuth } from "../../global-components/src";
import { PACOCA_API_URL } from "../../global-components/src/utils/vars";
import { BadgeCheck, AlertTriangle, X } from "lucide-react";
import { errorMessage } from "../../global-components/src/utils/text";

const CancelSubscription = () => {
    const { user, token, setUser } = useAuth();
    const { setMessage } = useMessage();
    const [loading, setLoading] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const navigate = useNavigate();

    // Redireciona se não tiver assinatura ativa
    // if (!user?.subscription_active) {
    //     navigate(`/@${user?.user_name}`);
    //     return null;
    // }

    const formatDate = (date: any) => {
        if (!date) return "—";
        const d = new Date(String(date).replace(" ", "T"));
        if (isNaN(d.getTime())) return "Data inválida";
        const day   = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year  = d.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const handleCancel = async () => {
        if (!confirmed) {
            setConfirmed(true);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(
                `${PACOCA_API_URL}/payments/cancel-subscription`,
                {},
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setMessage(response.data.message ?? "Assinatura cancelada com sucesso", "success");
            if(!user) return;
            setUser({ ...user, subscription_active: false });
            navigate(`/@${user?.user_name}`);
        } catch (err: any) {
            setMessage(errorMessage(err), "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Screen paddingTopTitle={true} title="Cancelar Assinatura">
            <Helmet>
                <title>Paçoca - Cancelar Assinatura</title>
                <meta name="description" content="Cancelar renovação automática do Verificado Paçoca" />
            </Helmet>

            <div className="container-form-center">
                <div className="col-form-center">
                    <form className="padding-baig-screen">
                        <div className="carad card- shadow-sm border-0">
                            <div className="form-center">

                                {/* Header */}
                                <h2 className="title2">Gerenciar Assinatura</h2>
                                <div className="line-form"></div>

                                {/* Status atual */}
                                <div className="card notification_opened border-0 w-100 mb-3">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <BadgeCheck size={28} color="var(--secondary-blue)" />
                                            <div>
                                                <div className="fw-semibold">Verificado ativo</div>
                                                <small className="opacity-75">
                                                    Renovação automática habilitada
                                                </small>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="opacity-75">Próxima cobrança</span>
                                            <span className="fw-semibold">{formatDate(user?.next_payment)}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="opacity-75">Valor</span>
                                            <span className="fw-semibold">
                                                R$ {(user?.is_company
                                                    ? (49.99 * (user?.subscription_months ?? 1))
                                                    : (9.99 * (user?.subscription_months ?? 1))
                                                ).toFixed(2).replace(".", ",")}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="opacity-75">Período</span>
                                            <span className="fw-semibold">
                                                {user?.subscription_months ?? 1} {(user?.subscription_months ?? 1) === 1 ? "mês" : "meses"}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                {/* Aviso de confirmação */}
                                {confirmed && (
                                    <div className="card border-0 w-100 mb-3" style={{ background: "rgba(255, 80, 80, 0.08)", border: "1px solid rgba(255,80,80,0.2) !important" }}>
                                        <div className="card-body d-flex gap-3 align-items-start">
                                            <AlertTriangle size={20} color="#ff5050" style={{ flexShrink: 0, marginTop: 2 }} />
                                            <div>
                                                <div className="fw-semibold mb-1" style={{ color: "#ff5050" }}>Tem certeza?</div>
                                                <small className="opacity-75">
                                                    Ao cancelar, a renovação automática será desativada. Seu verificado permanece ativo até <strong>{formatDate(user?.next_payment)}</strong> e não será renovado após essa data.
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="mt-3"></div>

                                {/* Botão principal */}
                                <button
                                    type="button"
                                    disabled={loading}
                                    onClick={handleCancel}
                                    className="btn-rouded btn"
                                    style={confirmed ? { background: "#ff5050", borderColor: "#ff5050" } : {}}
                                >
                                    {loading ? (
                                        <Spinner size="20px" />
                                    ) : confirmed ? (
                                        <>
                                            <X size={16} style={{ marginRight: 6 }} />
                                            Confirmar cancelamento
                                        </>
                                    ) : (
                                        "Cancelar renovação automática"
                                    )}
                                </button>

                                {/* Voltar */}
                                <p
                                    className="cancel user-select-none"
                                    onClick={() => confirmed ? setConfirmed(false) : navigate(-1)}
                                >
                                    {confirmed ? "Voltar" : "Manter assinatura"}
                                </p>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Screen>
    );
};

export default CancelSubscription;